import { MessagesStringAssets } from "../../assets/stringAssets";

export function composeMessageUsingStringAsset(baseMessage: string, substitutionString?: string, substitutionKeyword?: string): string {
  const _substitutionKeyword: string = substitutionKeyword === undefined ? MessagesStringAssets.substitutionKeyword : substitutionKeyword;

  const composedMessage: string = substitutionString === undefined ? baseMessage : baseMessage.replace(_substitutionKeyword, substitutionString);

  return composedMessage;
}